import { defineMessages } from 'react-intl';

export const componentErrorMessageDefinitions = defineMessages({
  errorOccured: {
    id: 'genericError.errorOccured',
    defaultMessage: 'An error occurred, please contact support.',
  },
});
